(function() {
  'use strict';

  function Controller(tFilter) {
    'ngInject';
    const vm = this;
    
    vm.resources = {
      title: tFilter('SETTING.CSV_IMPORTER.API_KEY.TITLE'),
      description: tFilter('SETTING.CSV_IMPORTER.API_KEY.DESCRIPTION'),
      label: tFilter('SETTING.CSV_IMPORTER.API_KEY.LABEL'),
      placeholder: tFilter('SETTING.CSV_IMPORTER.API_KEY.PLACEHOLDER'),
      requiredError: tFilter('SETTING.CSV_IMPORTER.API_KEY.REQUIRED_ERROR'),
      lengthError: tFilter('SETTING.CSV_IMPORTER.API_KEY.LENGTH_ERROR'),
    };
    
    vm.submitted = false;

    vm.$onInit = function() {
      if (!vm.apiKey) {
        vm.apiKey = '';
      }
    };

    vm.keyChange = function() {
      vm.onChange({apiKey: vm.apiKey});
    };
    
    vm.validate = function() {
      vm.submitted = true;
      return vm.apiKey && vm.apiKey.trim() !== '' && vm.apiKey.length === 64;
    };
    
    vm.isLengthValid = function() {
      return !vm.apiKey || vm.apiKey.length === 0 || vm.apiKey.length === 64;
    };
  }
    
  angular
    .module('eva2-angular')
    .component('csvApiKey', {
      bindings: {
        apiKey: '=',
        apiKeyError: '=?',
        onChange: '&',
        onValidate: '&'
      },
      template: require('./apiKey.html'),
      controller: Controller,
      controllerAs: 'vm'
    });
})();
